import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "./SubStockSetProduct.css";
import { Toast } from "components/ui";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import StockCard from "components/ui/StockCard";

const SubStockSetsProduct = React.memo(({ product, allData }) => {
  const location = useLocation();

  const innerChnages = location?.state?.innerChnages;
  const isEdit = location?.state?.edit || innerChnages;
  const isEditCatagory = location?.state?.isEditCatagory;

  const { setCountCart, countCart } = useGlobalContext();
  const [open, setOpen] = useState(false);
  const [btnTitle, setBtnTitle] = useState("Add");

  const addtoCart = () => {
    setBtnTitle("Added");
    setOpen(true);
  };

  const removeCart = () => {
    setBtnTitle("Add");
    setCountCart((prevCount) => prevCount - 1);
  };

  const selectedCartProducts = {
    ...product,
    isAddedInCart: true,
  };

  const handleClose = (reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <>
      <Grid item className="stock">
        <StockCard
          data={product}
          selectedCartProducts={selectedCartProducts}
          style={{ maxWidth: isEdit ? "430px" : "430px", minWidth: isEdit ? "430px" : "430px" }}
          {...(innerChnages && {
            isBtn: true,
            addtoCart: addtoCart,
            removeCart: removeCart,
            btnTilte: btnTitle,
          })}
          allData={allData}
        />
        {!isEditCatagory && (
          <Toast
            open={open}
            msg={`Design Has Been Added To Cart ${countCart}`}
            autoHideDuration={2000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            ContentProps={{
              sx: { backgroundColor: "#50C878" },
            }}
          />
        )}
      </Grid>
    </>
  );
});

export default React.memo(SubStockSetsProduct);
